module.exports = __webpack_public_path__ + "img/gb73-85-m4x10.prt.91c41d91.jpg";